<template>
  <div class="card card-default col-12 shadow" v-if="!noLinksConfigured">
    <div class="d-flex">
      <template v-for="(linkConfig, i) in links">
        <div
          class="mr-4 font-weight-bold p-2 cursor-pointer"
          @click="moveToElement(linkConfig.targetElementId)"
          v-if="linkConfig.targetElementId"
        >
          <span>{{i + 1}}. {{linkConfig.displayName}}</span>
          <template v-if="linkConfig.comment === 'Unser Service'">
            <Serverhero class="ml-2 sh-icon"/>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {createConfigGroupElementId} from 'components/ConfigGroup';
import {useStore} from "vuex";
import {computed} from "vue";
import Serverhero from "components/Icons/Serverhero";

export default {
  name: "SectionOverview",
  components: {Serverhero},
  setup() {
    const store = useStore();
    const configGroupsWithComment = Object.values(store.state.articleConfigGroups).filter(({cKommentar}) => {
      return cKommentar !== '';
    });

    const links = [
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte (RDP Hosting) Light',
        targetElementId: '',
      },
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte (Datenbank Hosting)',
        targetElementId: '',
      },
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte (RDP Hosting) Pro',
        targetElementId: '',
      },
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte (RDP Hosting) Start',
        targetElementId: '',
      },
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte (RDP Hosting) Enterprise',
        targetElementId: '',
      },
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte (LS-POS Hosting)',
        targetElementId: '',
      },
      {
        displayName: 'Laufzeitrabatte',
        comment: 'Laufzeitrabatte',
        targetElementId: '',
      },
      {
        displayName: 'RDP-Benutzer',
        comment: 'Zusätzlicher Remote-Desktop-Benutzer',
        targetElementId: '',
      },
      {
        displayName: 'DB-Wechselservice',
        comment: 'Kostenfreie Übernahme Ihrer Datenbank / Wechselservice',
        targetElementId: '',
      },
      {
        displayName: 'Managed-Optionen',
        comment: 'Managed-Optionen',
        targetElementId: '',
      },
    ];

    links.forEach((linkConfig) => {
      const configGroupsWithMatchingComment =
        configGroupsWithComment.filter(({cKommentar}) => cKommentar === linkConfig.comment);
      const targetId = store.state.sortOrders.articleConfigGroups.find((groupId) => {
        return !!configGroupsWithMatchingComment.find(({kKonfiggruppe}) => kKonfiggruppe === groupId);
      });

      if (targetId) {
        linkConfig.targetElementId = createConfigGroupElementId(targetId);
      }
    });

    return {
      links: links.filter(({targetElementId}) => targetElementId !== ''),
      noLinksConfigured: computed(() => Object.values(links).every(({targetElementId}) => targetElementId === '')),
      moveToElement(elementId) {
        const el = document.getElementById(elementId);
        if (el) {
          el.scrollIntoView(true);
        }
      }
    }
  }
}
</script>

<style scoped>
.sh-icon {
  width: 14px;
  height: 18px;
}
</style>